import React, { useState, useEffect } from 'react';
import FlightComponent from '../FlightComponent';
import messages from '../messages';
import { useIntl } from 'react-intl';
import { jsonApiAxios } from '../../../../services/api';
import useAuthenticate from '../../../../hooks/useAuthenticate';
import { useTranslatedNavigate } from '../../../../utils/routes';
import translations from '../../../../translations/main.json';
import { useHandleError } from '../../.../../../../services/api';

const subscriptionFlightsSchema = {
  attributes: [
    'subscriptionTrip',
    'flight_code',
    'flight_date',
    'departureAirport',
    'airline',
    'arrivalAirport',
    'status',
  ],
  subscriptionTrip: {
    ref: 'id',
  },
  departureAirport: {
    ref: 'id',
  },
  airline: {
    ref: 'id',
  },
  arrivalAirport: {
    ref: 'id',
  },
};

const tripSchema = {
  attributes: ['status'],
};

const FlightResults = (props: any) => {
  const { tripsArray } = props;
  const [flightsToSave, setFlightsToSave] = useState<any[]>([]);
  const [tripFlights, setTripFlights] = useState([]);
  const { token } = useAuthenticate();
  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const translatedNavigate = useTranslatedNavigate();
  const [handleError] = useHandleError();
  const { formatMessage } = useIntl();

  useEffect(() => {
    const fetchTrips = async () => {
      try {
        const promises = tripsArray.map(itemId =>
          jsonApiAxios.get(
            `/subscriptionTrips/${itemId}?include=allSubscriptionFlights.airline,allSubscriptionFlights.departureAirport,allSubscriptionFlights.arrivalAirport,subscriptionBillingCycle`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
        );

        const results = await Promise.all(promises);
        setTripFlights(results);
      } catch (error) {
        handleError(error);
      }
    };

    fetchTrips();
  }, [token]);

  const handleSaveTrips = async () => {
    const values = flightsToSave?.map((item: any) => ({
      id: item,
      status: 'Approved',
    }));
    await updateFlights(values);
    uppdateTrip();
  };

  const updateFlights = async (values: any) => {
    type Operation = {
      op: string;
      href: string;
      data: {
        type: string;
        id: any;
        attributes: {
          status: string;
        };
      };
    };

    const payload: { 'atomic:operations': Operation[] } = {
      'atomic:operations': [],
    };
    values?.forEach(value => {
      payload['atomic:operations'].push({
        op: 'update',
        href: `/subscriptionFlights/${value?.id}`,
        data: {
          type: 'subscriptionFlights',
          id: value?.id,
          attributes: {
            status: 'Approved',
          },
        },
      });
    });
    return jsonApiAxios.post('/operations', payload, {
      noSerialize: true,
    });
  };

  const uppdateTrip = async () => {
    const promises = tripsArray.map(itemId =>
      jsonApiAxios.patch(
        `/subscriptionTrips/${itemId}`,
        {
          status: 'Active',
        },
        {
          schema: tripSchema,
          type: 'subscriptionTrips',
          headers,
        }
      )
    );

    return Promise.all(promises).then(() => {
      translatedNavigate(
        '/' +
          translations['cc4.seo.route.account'] +
          '/' +
          translations['cc4.seo.route.my-premium']
      );
    });
  };

  return (
    <div>
      {tripFlights?.length && (
        <>
          <FlightComponent
            data={tripFlights.flatMap(
              item => item.all_subscription_flights || []
            )}
            addFlight={true}
            setFlightsToSave={setFlightsToSave}
            subscriptionBillingCycle={
              tripFlights[0]?.subscription_billing_cycle
            }
          />
          <div className="footer-button" style={{ marginTop: '20px' }}>
            <button
              onClick={() => handleSaveTrips()}
              disabled={!flightsToSave?.length}
            >
              {formatMessage(messages.saveTripsLabel)}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default FlightResults;
